export const environment = {
  name: '(DEVELOPMENT)',
  production: false,
  features: {
    textTranslation: false,
    textRephrase: false,
  },
  apiBaseUrl: 'https://deepl-api-test.bizerba.com/api/',
  azureAd: {
    clientId: 'de1c22b0-70e4-4a24-80d5-53c7a0333069',
    authority: 'https://login.microsoftonline.com/2898792b-c644-4207-bb78-a08f555def6c',
    redirectUri:'https://translate-test.bizerba.com/',
    scope: 'https://deepl-api-test.bizerba.com/user.access',
  }
};